import { Component, Input, OnInit } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { UserLoginService } from 'src/app/services/usuario-login.service'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-ajuda-suporte',
  templateUrl: './ajuda-suporte.component.html',
  styleUrls: ['./ajuda-suporte.component.css'],
  standalone: false
})
export class AjudaSuporteComponent implements OnInit {
  @Input() trustedUrl!: SafeUrl
  iframeHeight: number = 200
  isDiscente: boolean = false

  constructor(private userLoginService: UserLoginService, private sanitizer: DomSanitizer) {
    this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.servicedesk)
  }

  ngOnInit(): void {
    this.iframeHeight = window.innerHeight - 180
    this.userLoginService.user$.subscribe(user => {
      if (user) {
        user.roles.forEach(role => {
          if (role === 'DISCENTE') {
            this.isDiscente = true
          }
        })
      }
    })
  }
}
